const URL_CANDIDATE = /https?:\/\/[^\s<>"']+/giu;
const TRAILING_PUNCTUATION = /[),.!?;:]+$/u;

export type ChatTextSegment =
  | { readonly type: 'text'; readonly value: string }
  | { readonly type: 'link'; readonly value: string; readonly href: string };

export function sanitizeChatText(value: string): string {
  return [...value.replace(/\r\n?/gu, '\n')]
    .filter((character) => !isDisallowedControl(character))
    .join('')
    .trim();
}

export function linkifyChatText(value: string): readonly ChatTextSegment[] {
  const segments: ChatTextSegment[] = [];
  let offset = 0;

  for (const match of value.matchAll(URL_CANDIDATE)) {
    const index = match.index;
    const candidate = match[0];
    if (index > offset) {
      segments.push({ type: 'text', value: value.slice(offset, index) });
    }

    const trailing = candidate.match(TRAILING_PUNCTUATION)?.[0] ?? '';
    const linkText = trailing === '' ? candidate : candidate.slice(0, -trailing.length);
    const href = safeHttpUrl(linkText);
    if (href === null) {
      segments.push({ type: 'text', value: candidate });
    } else {
      segments.push({ type: 'link', value: linkText, href });
      if (trailing !== '') {
        segments.push({ type: 'text', value: trailing });
      }
    }
    offset = index + candidate.length;
  }

  if (offset < value.length) {
    segments.push({ type: 'text', value: value.slice(offset) });
  }
  return segments.length === 0 ? [{ type: 'text', value }] : segments;
}

function safeHttpUrl(value: string): string | null {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
}

function isDisallowedControl(character: string): boolean {
  const codePoint = character.codePointAt(0) ?? 0;
  return (
    codePoint <= 0x08 ||
    codePoint === 0x0b ||
    codePoint === 0x0c ||
    (codePoint >= 0x0e && codePoint <= 0x1f) ||
    codePoint === 0x7f ||
    (codePoint >= 0x202a && codePoint <= 0x202e) ||
    (codePoint >= 0x2066 && codePoint <= 0x2069)
  );
}
